import { createSlice } from '@reduxjs/toolkit';
import type {PayloadAction} from "@reduxjs/toolkit"

const FilesSclice = createSlice({
	name: "files",
	initialState: {
		downloadQueue: new Array<string>(),
		uploadQueue: new Array<string>(),
		exports: [],
		imports: [],
		progressList: {},
		fileUploadDialogOpen: false,
		fileManagerVisible: true,
		waitingForImport: false,
		waitingForMerge: false,
	},
	reducers: {
		registerUploads(state, action: PayloadAction<string[]>)
		{
			state.uploadQueue = action.payload;
		},
		registerDownloads(state, action: PayloadAction<string[]>)
		{
			state.downloadQueue = action.payload;
		},
		clearDownloads(state, action: PayloadAction<undefined>)
		{
			state.downloadQueue = new Array<string>();
		},
		clearUploads(state, action: PayloadAction<undefined>)
		{
			state.uploadQueue = new Array<string>();
		},
		registerFileLoadProgress(state, action: PayloadAction<{ fileId: string }>)
		{
			state.progressList[action.payload.fileId] = {};
		},
		removeFileLoad(state, action: PayloadAction<{ fileId: string }>)
		{
			delete state.progressList[action.payload.fileId];
		},
		openFileUpload(state)
		{
			state.fileUploadDialogOpen = true;
		},
		fileUploadDone(state)
		{
			state.fileUploadDialogOpen = false;
		},
		setFileManagerVisible(state, action: PayloadAction<boolean>)
		{
			state.fileManagerVisible = action.payload;
		},
		registerExports(state, action) // TODO: what exactly gets here?
		{
			state.exports = action.payload;
		},
		registerImports(state, action) // TODO: what exactly gets here?
		{
			state.imports = action.payload;
		},
		setWaitingForImport(state, action: PayloadAction<boolean>)
		{
			state.waitingForImport = action.payload;
		},
		setWaitingForMerge(state, action: PayloadAction<boolean>)
		{
			state.waitingForMerge = action.payload;
		},
	},
});

export default FilesSclice;
